import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string;
  error?: string;
  hint?: string;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, error, hint, id, rows = 4, ...props }, ref) => {
    const tid = id || props.name;
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={tid} className="kicker mb-2 block">{label}</label>
        )}
        <textarea
          ref={ref}
          id={tid}
          rows={rows}
          className={cn(
            'w-full bg-bg-subtle border border-border rounded-sm',
            'px-3.5 py-2.5 text-sm text-text placeholder:text-text-dim',
            'transition-colors duration-150 resize-y',
            'hover:border-border-strong focus:border-brass-400 focus:bg-bg-panel',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            error && 'border-danger/60 focus:border-danger',
            className,
          )}
          {...props}
        />
        {error ? (
          <p className="mt-1.5 text-xs text-danger">{error}</p>
        ) : hint ? (
          <p className="mt-1.5 text-xs text-text-dim">{hint}</p>
        ) : null}
      </div>
    );
  },
);
Textarea.displayName = 'Textarea';
